

exports.__esModule = true;
exports.$registerDirective = $registerDirective;

var _angular = require("angular");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function $registerDirective(tag, definition) {

    var directiveName = tag.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
    });

    return _angular2["default"].module().directive(directiveName, definition);
}

_angular2["default"].value("$registerDirective", $registerDirective);


/*****************
 ** WEBPACK FOOTER
 ** ./components/squid/dist/ng/directive.js
 ** module id = 138
 ** module chunks = 1
 **/